// Funciones generales para arrays.
// eslint-disable-next-line no-unused-vars
import * as FxLog from './FxLog';

/**
 * Orders an array of objects by a specified field and sort direction.
 * @param {Array<Object>} arrayToSort - The array of objects to be sorted.
 * @param {string} fieldName - The name of the field to sort by (e.g., 'name', 'id').
 * @param {string} sortOrder - The sort order: 'asc' for ascending, 'desc' for descending. Defaults to 'asc'.
 * @returns {Array<Object>} A new sorted array.
 */
export const sortArrayByField = (arrayToSort, fieldName, sortOrder = 'asc') => {
  if (!arrayToSort || !Array.isArray(arrayToSort)) {
    console.error("sortArrayByField: Invalid input. Expected an array.");
    return [];
  }
  if (!fieldName || typeof fieldName !== 'string') {
    console.error("sortArrayByField: Invalid fieldName. Expected a non-empty string.");
    return [...arrayToSort];
  }

  const isDescending = sortOrder.toLowerCase() === 'desc';

  // Creamos una copia del array para no mutar el original
  const sortedArray = [...arrayToSort];

  return sortedArray.sort((itemA, itemB) => {
    const valueA = itemA[fieldName] ? String(itemA[fieldName]).toLowerCase() : '';
    const valueB = itemB[fieldName] ? String(itemB[fieldName]).toLowerCase() : '';

    if (valueA < valueB) {
      return isDescending ? 1 : -1;
    }
    if (valueA > valueB) {
      return isDescending ? -1 : 1;
    }
    return 0;
  });
};